<template>
    <div>
      <q-card>

      </q-card>
    </div>
  </template>
  
  <script>
  export default {
    name: "PaginaInicial",
  };
  </script>